<template>
  <div class="wrapper">
    <!-- <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}"> -->

    <side-bar :background-color="backgroundColor">
	<ul class="nav">
		<li class="nav-item router-link-active"  v-for="(item,index) in userMenu" @click="setActive(index)">
			<a class="nav-link" :href="'/#/'+item.url">
			<i class="tim-icons icon-chart-pie-36"></i>
			<p>{{item.funcLangCode}}</p>
			</a>
		</li>
	</ul>
     <!-- 
	 :class="{'active':index==activeIndex}"
	 <sidebar-link to="/drawing">
        <i class="tim-icons icon-chart-pie-36"></i>
        <template>
          <p>图纸管理</p>
        </template>
      </sidebar-link>

      <sidebar-link to="/company">
        <i class="tim-icons icon-puzzle-10"></i>
        <template>
          <p>客户管理</p>
        </template>
      </sidebar-link>
	  
	  <sidebar-link to="/orders">
	    <i class="tim-icons icon-puzzle-10"></i>
	    <template>
	      <p>订单管理</p>
	    </template>
	  </sidebar-link>
	  
	  <sidebar-link to="/users">
	    <i class="tim-icons icon-puzzle-10"></i>
	    <template>
	      <p>用户管理</p>
	    </template>
	  </sidebar-link>
	  
	  <sidebar-link to="/invite">
	    <i class="tim-icons icon-puzzle-10"></i>
	    <template>
	      <p>邀请注册</p>
	    </template>
	  </sidebar-link>
	  
      <sidebar-link to="/user">
        <i class="tim-icons icon-single-02"></i>
        <template>
          <p>个人资料</p>
        </template>
      </sidebar-link> -->
	  
    </side-bar>

    <sidebar-share :background-color.sync="backgroundColor"></sidebar-share>

    <div class="main-panel" :data="backgroundColor">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./DashboardContent.vue";
import SidebarShare from "./SidebarSharePlugin.vue";
import MobileMenu from "./MobileMenu.vue";
import SideBar from "@/components/SidebarPlugin/SideBar.vue";
import SidebarLink from "@/components/SidebarPlugin/SidebarLink.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    SideBar,
    SidebarLink,
    SidebarShare,
  },
  data() {
    return {
      backgroundColor: "green",
	  userMenu:[],
	  activeIndex:0
    };
  },
  created(){
	 this.userMenu=JSON.parse(sessionStorage.getItem("userMenu"));
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    },	
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
	setActive(val){
		this.activeIndex=val
	}
  },
};
</script>
